import React from "react";
import { BsLinkedin, BsGithub } from "react-icons/bs";

const HeaderSocials = () => {
  return (
    <div className="hero__socials">
      <a
        className="header__social-link"
        href="https://www.linkedin.com/in/kushtrimshabani/"
        target="_blank"
        rel="noreferrer"
        aria-label="Visit LinkedIn profile"
      >
        <BsLinkedin />
      </a>
      <a
        className="header__social-link"
        href="https://github.com/KushtrimShabani"
        target="_blank"
        rel="noreferrer"
        aria-label="Visit GitHub profile"
      >
        <BsGithub />
      </a>
    </div>
  );
};

export default HeaderSocials;
